module.exports = __webpack_public_path__ + "img/goodwe.26176162.svg";